module.exports = __webpack_public_path__ + "static/media/insured-car.ad84280d.png";